import { __read, __spread } from "tslib";
import { formatValue as valueFormatter } from '@keen.io/charts-utils';
import { KEEN_TABLE_INTERVAL, KEEN_KEY } from '@keen.io/parser';
import { DIFFERENCE } from '../../constants';
export var transform = function (_a) {
    var query = _a.query, chartSettings = _a.chartSettings;
    var keys = chartSettings.keys, data = chartSettings.data, formatValue = chartSettings.formatValue, type = chartSettings.type;
    var interval = query.interval, analysisType = query.analysis_type, eventCollection = query.event_collection;
    var _b = __read(keys, 1), valueSelector = _b[0];
    if (interval) {
        var lastItem = data[data.length - 1];
        var previousItem = data[data.length - 2];
        var currentValue_1 = lastItem[valueSelector];
        var previousValue_1 = previousItem ? previousItem[valueSelector] : 0;
        var additionalColumns = type !== 'simple' ? [DIFFERENCE] : [];
        var columns = __spread([
            KEEN_TABLE_INTERVAL,
            analysisType + "." + eventCollection
        ], additionalColumns);
        return __spread([
            columns
        ], [previousItem, lastItem].map(function (item, idx) { return __spread([
            item[KEEN_KEY],
            valueFormatter(item[valueSelector], formatValue)
        ], (type !== 'simple'
            ? [idx === 0 ? 0 : currentValue_1 - previousValue_1]
            : [])); }));
    }
    else {
        return __spread([
            [analysisType + "." + eventCollection]
        ], data.map(function (item) { return [valueFormatter(item[valueSelector], formatValue)]; }));
    }
};
